import { render, staticRenderFns } from "./gauge.vue?vue&type=template&id=53b9bf4e&"
import script from "./gauge.vue?vue&type=script&lang=js&"
export * from "./gauge.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports